import { AlertDashboard } from "components/dashboard-components/AlertDashboard"
import { BalanceBeginingDay } from "components/dashboard-components/BalanceBeginingDay"
import { ButtonChart } from "components/dashboard-components/ButtonChart"
import { ChartArea } from "components/dashboard-components/ChartArea"
import { DashboardTable } from "components/dashboard-components/DashboardTable"
import { DrawDown } from "components/dashboard-components/DrawDown"
import { Statistics } from "components/dashboard-components/Statistics"
import { StatisticsDays } from "components/dashboard-components/StatisticsDays"
import { UserInfo } from "components/dashboard-components/UserInfo"
import { CNotification } from "components/widget/CNotification"
import { LoadingPage } from "components/widget/Loader/LoadingPage"
import { useAccountDashboard } from "hooks/dashboard-hooks"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { LayoutStore } from "store/layout-store"

export const Dashboard = () => {
    let parms = useParams()
    const { setUserId } = LayoutStore()
    const { data: accountData, refetch, isLoading, isFetching } = useAccountDashboard('10')


    return (
        <>
            <div className="flex flex-col w-full">
                <UserInfo accountData={accountData} />

                <div className="flex flex-col w-full px-5 mt-4">
                    <AlertDashboard
                        status={accountData?.data?.data?.status}
                        statics={accountData?.data?.data?.statics}
                    />
                </div>

                <div className="flex flex-col w-full px-5 mt-4 md:mt-10">
                    <div className="flex flex-wrap items-center w-full ">
                        <StatisticsDays
                            accountData={accountData?.data?.data}
                            statics={accountData?.data?.data?.statics}
                            metrics={accountData?.data?.data?.data?.data?.metrics}
                        />
                        <BalanceBeginingDay
                            statics={accountData?.data?.data?.statics}
                            balance={accountData?.data?.data?.balance}
                        />
                    </div>
                </div>

                <div className="flex flex-col w-full px-5 mt-2 md:mt-4">
                    <div className="flex flex-wrap w-full ">
                        <div className="md:w-[70%] w-full md:pl-2 pl-0">
                            <ChartArea
                                chart={accountData?.data?.data?.statics?.chart_data}
                            >
                                <ButtonChart AccountId={parms?.uId} />
                            </ChartArea>
                        </div>
                        <div className="md:w-[30%] w-full md:pr-2 pr-0 md:mt-0 mt-2">
                            <DrawDown
                                account={accountData?.data?.data}
                                metrics={accountData?.data?.data?.data?.data?.metrics}
                                statics={accountData?.data?.data?.statics}
                                licence={accountData?.data?.data?.licence}
                            />
                        </div>

                    </div>
                </div>

                <div className="flex flex-col w-full px-5 mt-2 md:mt-4">
                    <div className="flex flex-wrap w-full ">
                        <Statistics
                            metrics={accountData?.data?.data?.data?.data?.metrics}
                        />
                    </div>
                </div>

                <div className="flex flex-col w-full px-5 mt-2 md:mt-4">
                    <div className="flex flex-wrap w-full ">
                        <DashboardTable
                            trades={accountData?.data?.data?.data?.data?.trades}
                            title="جزئیات معاملات"
                        />
                    </div>
                </div>

            </div>

            <CNotification visible={isFetching} isLoading={true} message="در حال بروزرسانی" />
            {isLoading && <LoadingPage />}
        </>
    )
}